// src/pages/LoginPage.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ResetPwd from "../components/ResetPassword";

const ResetPassword = () => {
  return (
    <>
      <Header />
      <ResetPwd />
      <Footer />
    </>
  );
};

export default ResetPassword;
